document.querySelectorAll('[data-product]').forEach(page => {
  const data = page.querySelector('[data-variant-json]');
  if (!data) return;
  const variants = JSON.parse(data.textContent);
  const selects = [...page.querySelectorAll('[data-option-select]')];
  const idInput = page.querySelector('[data-variant-id]');
  const button = page.querySelector('[data-add-button]');
  const sticky = page.querySelector('[data-sticky-cart]');
  const stickyButton = page.querySelector('[data-sticky-add]');
  const quantity = page.querySelector('[name="quantity"]');
  function syncSticky() {
    if (!sticky) return;
    stickyButton.disabled = button.disabled;
    stickyButton.textContent = button.textContent;
    sticky.querySelector('[data-sticky-price]').textContent = page.querySelector('[data-variant-price]').textContent;
    sticky.querySelector('[data-sticky-selection]').textContent = selects.map(select => select.value).join(' · ') + ' · Qty ' + (quantity.value || '1');
  }
  if (sticky) {
    document.body.classList.add('ft-has-sticky-cart');
    new IntersectionObserver(entries => {
      sticky.hidden = entries[0].boundingClientRect.bottom > 0;
    }, { threshold: 0 }).observe(button);
    quantity.addEventListener('input', syncSticky);
    quantity.addEventListener('change', syncSticky);
  }
  const main = page.querySelector('[data-gallery-main]');
  function showImage(id) {
    const thumb = [...page.querySelectorAll('[data-gallery-thumb]')].find(el => el.dataset.mediaId === String(id));
    if (!thumb || !main) return;
    main.src = thumb.dataset.src;
    main.removeAttribute('srcset');
    main.alt = thumb.dataset.alt;
    page.querySelectorAll('[data-gallery-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el === thumb)));
  }
  page.querySelectorAll('[data-gallery-thumb]').forEach(thumb => thumb.addEventListener('click', () => showImage(thumb.dataset.mediaId)));
  function update(changed) {
    let values = selects.map(select => select.value);
    let variant = variants.find(v => v.options.every((value, i) => value === values[i]));
    if (!variant && changed === 0) {
      variant = variants.find(v => v.options[0] === values[0]);
      if (variant) selects.forEach((select, i) => { select.value = variant.options[i]; });
    }
    values = selects.map(select => select.value);
    selects.slice(1).forEach((select, offset) => [...select.options].forEach(option => {
      option.disabled = !variants.some(v => v.options[0] === values[0] && v.options[offset + 1] === option.value);
    }));
    const preview = button.dataset.preview === 'true';
    button.disabled = preview || !variant || !variant.available;
    button.textContent = preview ? 'Coming soon' : !variant ? 'Unavailable combination' : variant.available ? 'Add to bag' : 'Sold out';
    idInput.value = variant ? variant.id : '';
    const price = page.querySelector('[data-variant-price]');
    if (price && variant && !price.dataset.fixed) price.textContent = variant.price;
    syncSticky();
    if (variant) {
      showImage(variant.image);
      const url = new URL(location.href);
      url.searchParams.set('variant', variant.id);
      history.replaceState({}, '', url);
    }
  }
  selects.forEach((select, index) => select.addEventListener('change', () => update(index)));
  update(-1);
});
